import useScreenSizeContext from '@cohort/wallet/hooks/useScreenSize';
import CampaignPageDesktop from '@cohort/wallet/pages/store/CampaignPageDesktop';
import CampaignPageMobile from '@cohort/wallet/pages/store/CampaignPageMobile';
import React from 'react';

const CampaignPage: React.FC = () => {
  const {isMobile} = useScreenSizeContext();
  const Page = isMobile ? CampaignPageMobile : CampaignPageDesktop;

  return <Page />;
};

export default CampaignPage;
